import { gql, useQuery } from '@apollo/client'

import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { get, isEmpty } from 'lodash'
import Skeleton from '@material-ui/lab/Skeleton'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/styles'

import { PageHeader } from 'components/page-header'
import RouterLinkButton from 'components/router-link-button'
import Error from 'components/error'

import FacilityListItem from './facility-list-item'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}))

const Facilities = ({ facilities, hasCoachProfile }) => {
  return (
    !isEmpty(facilities) &&
    facilities.map((facility, index) => {
      const hasAvailabilities = !isEmpty(facility.availabilities)

      return (
        <FacilityListItem
          key={facility?.id}
          facility={facility}
          index={index}
          hasAvailabilities={hasAvailabilities}
          hasCoachProfile={hasCoachProfile}
        />
      )
    })
  )
}

const FacilitiesPage = () => {
  const GET_FACILITIES = gql`
    query CoachFacilities {
      currentUser {
        attributes {
          ... on Coach {
            coachProfile {
              id
            }
            facilities {
              id
              name
              address1
              address2
              city
              state
              zip
              timezone
              url
              phone
              externalFacilityId
              isPrivate
              availabilities {
                id
                timeSlots {
                  day
                  startTime
                  endTime
                }
              }
              coachProfilesFacilities {
                visible
              }
            }
          }
        }
      }
    }
  `

  const styles = useStyles()
  const { path } = useRouteMatch()
  const [isCoachOnboardingEnabled] = useFeatureFlags([
    flags.FLAG_COACH_ONBOARDING,
  ])
  const crumbs = [
    {
      label: 'Home',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]
  if (isCoachOnboardingEnabled) {
    crumbs.push({
      label: 'Settings',
      to: path
        .split('/')
        .slice(0, 3)
        .join('/'),
    })
  }
  const { data, loading, error } = useQuery(GET_FACILITIES)

  if (error) return <Error error={error} />

  return (
    <>
      <PageHeader
        title="Facilities"
        crumbs={crumbs}
        actions={
          <RouterLinkButton
            variant="contained"
            color="primary"
            to={`${path}/new`}
          >
            Add Facility
          </RouterLinkButton>
        }
        fixedMobileActions
      />

      <Container className={styles.container}>
        {loading ? (
          <Skeleton />
        ) : (
          <Facilities
            facilities={get(data, 'currentUser.attributes.facilities')}
            hasCoachProfile={data.currentUser.attributes.coachProfile !== null}
          />
        )}
      </Container>
    </>
  )
}

export default FacilitiesPage
